// Ensure every API request carries the HttpOnly session cookie.
//
// The browser only sends a cookie back to the domain that set it, so enabling
// credentials globally exposes nothing to third parties — it simply lets the
// backend authenticate requests via the `access_token` cookie instead of a
// localStorage-held bearer token. Importing this module once (from index.tsx)
// applies the behavior to both axios and the native fetch API.
import axios from 'axios'

axios.defaults.withCredentials = true

if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
  const originalFetch = window.fetch.bind(window)
  window.fetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const withCreds: RequestInit =
      init && init.credentials !== undefined ? init : { ...(init || {}), credentials: 'include' }
    return originalFetch(input, withCreds)
  }
}

export {}
